import React from "react";

import { ZeosFontSize } from "../../services/helpers/ThemeHelpers";
import { ZeosLabel } from "./ZeosLabel";

interface IZeosCheckboxGroupProps {
  label?: string;
  options: string[];
  selected: string[];
  onChange: (updated: string[]) => void;
  disabled?: boolean;
  layout?: "vertical" | "horizontal";
  required?: boolean;
}

export const ZeosCheckboxGroup = (props: IZeosCheckboxGroupProps) => {
  const {
    label,
    options,
    selected,
    onChange,
    disabled,
    layout = "vertical",
    required = false,
  } = props;
  const toggle = (option: string) => {
    if (selected.includes(option)) {
      onChange(selected.filter((item) => item !== option));
    } else {
      onChange([...selected, option]);
    }
  };

  return (
    <div className="mb-4">
      {label && <ZeosLabel label={label} required={required} />}
      <div
        className={`flex ${
          layout === "vertical" ? "flex-col gap-2" : "flex-row gap-4"
        }`}
      >
        {options.map((option) => (
          <label
            key={option}
            className={`inline-flex items-center text-${ZeosFontSize.lg} font-light text-zeos-black font-sans`}
          >
            <input
              type="checkbox"
              checked={selected.includes(option)}
              onChange={() => toggle(option)}
              disabled={disabled}
              className="
              appearance-none relative w-4 h-4 mr-2 border-2 border-zeos-grey-md
              rounded-sm bg-white cursor-pointer
              checked:border-zeos-orange-dk
              disabled:opacity-70
              before:content-[''] before:absolute before:inset-0
              before:flex before:items-center before:justify-center
              checked:before:content-['✓'] checked:before:text-zeos-orange-dk
              checked:before:text-[0.9rem] checked:before:font-bold
            "
            />
            <span className="whitespace-nowrap">{option}</span>
          </label>
        ))}
      </div>
    </div>
  );
};
